<!--
The "value" property is expected to be an array of objects that contain the following fields:

id       - unique ID of an element, used as key for the list
enabled  - signifies if the element is enabled or not
selected - signifies if the element is selected or not (this property is modified!)
name     - label displayed next to the checkbox
-->

<template>
  <div class="checklist">
    <div v-for="item in value" :key="item.id" class="checklist-item">
      <CheckBox class="checklist-item__checkbox" v-model="item.selected" :enabled="item.enabled" @input="input" />
      <CheckBoxLabel class="checklist-item__label" v-model="item.selected" :enabled="item.enabled" @input="input"
        :text="item.name" :html="item.html" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import CheckBox from '@/components/CheckBox.vue'
import CheckBoxLabel from '@/components/CheckBoxLabel.vue'
import MediaDetector from '@/utils/MediaDetector'

@Component({
  mixins: [
    MediaDetector,
  ],
  components: {
    CheckBox,
    CheckBoxLabel,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
})
export default class CheckList extends Vue {
  clear () {
    this.value.forEach(item => {
      item.selected = false
    })
  }

  selectAll () {
    this.value.forEach(item => {
      if (item.enabled) item.selected = true
    })
  }

  input () {
    if (!this.isMobile) this.$emit('input')
  }
}
</script>

<style lang="scss">
.checklist-item {
  display: flex;
  align-items: center;
  padding-bottom: 24px;

  &__label:not(.checkbox-label--disabled) {
    &:hover {
      color: #009FEA;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckList.vue